export enum VIEW_MODE {
  LIST = 'List',
  SINGLE = 'Single',
}
export type ReviewPanelSettingsT = {
  viewMode: VIEW_MODE;
  enableAcceptAll: boolean;
  showAllAnnotations: boolean;
  enableContinuousPlayback: boolean;
};